import React from "react";
import Icon from "../../icons/Icon";

//interfaces and helpers
import { IContentImagePreviewPanel } from "../../../../interfaces/media/IContentPreviewCarousel";
import { getListIconLibrary } from "../../../../helpers/IconLibrary";



const ContentImagePreviewPanel = ({className, mediaItems, maxVisible, totalMediaItems}: IContentImagePreviewPanel) => {  
    if (!Array.isArray(mediaItems) || mediaItems.length === 0) {
        return <></>;
    }

    const extraCount = totalMediaItems > maxVisible ? totalMediaItems - maxVisible : 0;
    const displayedImages = Array.isArray(mediaItems) ? mediaItems.slice(0, maxVisible) : [];
    const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        const target = event.target as HTMLImageElement;
        target.style.display = "none";
    };

    function isLastVisibleItem(index: number) {
        return index === maxVisible - 1 && extraCount > 0;
    };
    
    return (
        <div className={`content-image-preview-panel ${className ?? ""}`}>
            {displayedImages.map((image, index) => (
                <div key={image.url} className={`image-wrapper`}>
                    <img src={`${image?.thumbnail?.url}?size=thumbnail`} alt={`content preview ${index + 1} of ${displayedImages.length}`} className="content-image-preview-item" onError={handleImageError}/>
                        
                    {isLastVisibleItem(index) 
                    ?   <div className="content-image-preview-item-overlay">
                            <span className="item-overlay-count">+{extraCount}</span>
                        </div>
                    : <div className={`content-image-preview-item-icon-overlay ${!image?.url && "imageless"}`}>
                        <span className="item-overlay-icon"><Icon iconName={getListIconLibrary(image.mediaType)} color="var(--thriveWhite)" sizeInPx="12"/></span>
                    </div>
                    
                 }
                </div>
            ))}
        </div>
    );
};

export default ContentImagePreviewPanel;
